import { render, staticRenderFns } from "./WeatherMeteorologyPage.vue?vue&type=template&id=c4c7b996&"
import script from "./WeatherMeteorologyPage.vue?vue&type=script&lang=js&"
export * from "./WeatherMeteorologyPage.vue?vue&type=script&lang=js&"
import style0 from "./WeatherMeteorologyPage.vue?vue&type=style&index=0&id=c4c7b996&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports